import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "components/Buttons";
import { SubscriptionPlanStyles } from "./styled";
import Icon from "components/Icon/Icon";
import { XCircleIcon, XIcon } from "@phosphor-icons/react";
import Textarea from "components/TextArea";
import StatusPillButtons from "components/Buttons/StatusPillButtons";
import PillButtons from "components/Buttons/PillButtons";
import { RightIconOutlineRegularIcon } from "assets/SVGComponents";
import Select from "components/Select";

const SubscriptionPlanModal = ({
  show,
  onHide,
  currentPlan,
  onConfirm,
  loading,
  selectedPlan,
  setSelectedPlan,
  subscriptionMenuItems
}) => {
  const [reason, setReason] = useState("");

  const handleHide = () => {
    setSelectedPlan(null);
    setReason("");
    onHide();
  };

  const handleConfirm = () => {
    onConfirm(reason.trim());
    setReason("");
  };

  const confirmDisabled = loading || !reason.trim() || !selectedPlan;

  const currentPlanName = currentPlan || "";
  const selectedPlanName = selectedPlan?.label || "";

  const buttonLabel =
    currentPlanName && selectedPlanName
      ? `Change ${currentPlanName} to ${selectedPlanName}`
      : "Change Plan";

  return (
    <SubscriptionPlanStyles
      show={show}
      onHide={handleHide}
      className="centered-modal"
    >
      <Modal.Header>
        <Modal.Title>
          {selectedPlanName
            ? `Change ${currentPlanName} to ${selectedPlanName}`
            : "Change Subscription"}
        </Modal.Title>

        <div onClick={handleHide} className="close-icon-wrapper">
          <Icon component={XIcon} size={24} />
        </div>
      </Modal.Header>

      <Modal.Body>
        <Select
          id="type"
          label="Choose Subscription"
          value={selectedPlan?.value || ""}
          onChange={(value) => {
            const selected = subscriptionMenuItems.find(
              (item) => item.value === value
            );

            setSelectedPlan(selected);
          }}
          placeholder="Choose Subscription"
          options={subscriptionMenuItems}
        />

        {selectedPlan?.plan?.proposal_limit && (
          <p>
            Weekly Proposal Limit: {selectedPlan?.plan?.proposal_limit} credits
          </p>
        )}

        <div className="form-group">
          <Textarea
            id="reason"
            required
            label="Reason for modification"
            size="M"
            value={reason || ""}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for modification"
          />
        </div>

        <p>Do you want to continue?</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide} disabled={loading}>
          Cancel
        </Button>

        <Button onClick={handleConfirm} disabled={confirmDisabled}>
          {loading ? "Please wait..." : buttonLabel}
        </Button>
      </Modal.Footer>
    </SubscriptionPlanStyles>
  );
};

export default SubscriptionPlanModal;
